import React from 'react'
import PropTypes from 'prop-types'

const icon = (paths, { size = 20, filled = false } = {}) => {
  const Icon = ({ className }) => (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      aria-hidden='true'
    >
      {paths}
    </svg>
  )
  Icon.propTypes = { className: PropTypes.string }
  Icon.defaultProps = { className: undefined }
  return Icon
}

export const Layers = icon(
  <>
    <path d='M12 3l9 5-9 5-9-5 9-5z' />
    <path d='M3 13l9 5 9-5' />
  </>,
)

export const Pause = icon(<path d='M6 5h4v14H6zM14 5h4v14h-4z' />, { filled: true })

export const Play = icon(<path d='M8 5v14l11-7z' />, { filled: true })

export const Crosshair = icon(
  <>
    <circle cx='12' cy='12' r='9' />
    <path d='M22 12h-4M6 12H2M12 6V2M12 22v-4' />
  </>,
)

export const Film = icon(
  <>
    <rect x='2' y='2' width='20' height='20' rx='2.18' ry='2.18' />
    <path d='M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5' />
  </>,
)

export const EyeOff = icon(
  <>
    <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' />
    <path d='M1 1l22 22' />
  </>,
  { size: 16 },
)

export const Undo = icon(
  <>
    <path d='M9 14L4 9l5-5' />
    <path d='M20 20v-7a4 4 0 0 0-4-4H4' />
  </>,
  { size: 16 },
)
